import script from "./FuncList.vue?vue&type=script&setup=true&lang=js"
export * from "./FuncList.vue?vue&type=script&setup=true&lang=js"

import "./FuncList.vue?vue&type=style&index=0&id=5b2324c0&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b2324c0"]])

export default __exports__